import React, { useState } from 'react';
import { CustomStack, SectionWrapper } from '@components/Styles/CommonStyle';
import { CustomButton } from '@components/Styles/ButtonStyle';
import {
  CustomTableContainer,
  CustomTable,
  CustomTableRow,
  CustomHeaderCell,
  CustomBodyCell,
  CustomSorting,
} from '@components/Styles/TableStyle';
import { TableHead, TableBody, Select, MenuItem } from '@mui/material';
import { Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { theme } from '@components/Styles/theme';
import { formatAmount } from '@utils/formatter';
import NewCommentBadge from '@/components/common/Shared/NewCommentBadge';
import { Checkbox } from '@mui/material';
import { useDialog } from '@context/DialogContext';
import Pagination from '@components/common/Shared/Pagination';
import { useLoading } from '@context/LoadingContext';
import api from '@api/axios';
import { CustomIconButton } from '@components/Styles/IconButtonStyle';

const ProjectListTableRowV2 = ({
  page,
  limit,
  setLimit,
  staticSearch,
  setStaticSearch,
  projectList,
  projectListTotal,
  checkedProjectList,
  handleCheckboxChange,
  navigate,
  onSearch,
  getYearlyFinance,
  getProjectStatus,
}) => {
  const { showLoading, hideLoading } = useLoading();
  const { showDialog } = useDialog();

  // 관심 사업 토글
  const handleFavoriteToggle = (projectId, isFavorite) => {
    showLoading();
    if (isFavorite === 0) {
      api
        .post('/api/project/createProjectFavorite', {
          projectId: projectId,
        })
        .then((res) => {
          console.log('handleFavoriteToggle res');
          console.log(res);
          onSearch({ page: page, manualSearch: false, status: '', init: false });
          getYearlyFinance();
          getProjectStatus();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          hideLoading();
        });
    } else {
      api
        .post('/api/project/deleteProjectFavorite', {
          projectId: projectId,
        })
        .then((res) => {
          console.log('handleFavoriteToggle res');
          console.log(res);
          onSearch({ page: page, manualSearch: false, status: '', init: false });
          getYearlyFinance();
          getProjectStatus();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          hideLoading();
        });
    }
  };

  const onDeleteProject = () => {
    if (checkedProjectList.length === 0) {
      showDialog({
        type: 'alert',
        title: '확인',
        message: '삭제할 프로젝트를 선택해 주세요.',
      });
    } else {
      showDialog({
        type: 'confirm',
        title: '삭제',
        message: '정말 삭제하시겠습니까?',
        onConfirm: () => {
          showLoading();
          api
            .delete('/api/project/deleteProject', {
              params: {
                ids: checkedProjectList.join(','),
                isProjectConfirm: true,
              },
            })
            .then((res) => {
              console.log('onDeleteProject res');
              console.log(res);
              if (res.status === 201) {
                showDialog({
                  type: 'alert',
                  title: '확인',
                  message: '삭제되었습니다.',
                });
                onSearch({ page: page, manualSearch: false, status: '', init: false });
                getYearlyFinance();
                getProjectStatus();
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              hideLoading();
            });
        },
      });
    }
  };

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack justifyContent="spaceBetween" mb={2}>
          <Typography sx={theme.typography.h4}>신규 사업 리스트</Typography>
          <CustomStack justifyContent="spaceBetween" mb={2}>
            <CustomButton
              onClick={() => {
                navigate('/project/projectCreate');
              }}
            >
              신규 사업 등록
            </CustomButton>
            <CustomButton
              color="error"
              onClick={() => {
                onDeleteProject();
              }}
            >
              삭제
            </CustomButton>
          </CustomStack>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable>
            <TableHead>
              <CustomTableRow>
                <CustomHeaderCell align="center">선택</CustomHeaderCell>
                <CustomHeaderCell align="center">No</CustomHeaderCell>
                <CustomHeaderCell align="center">
                  관심 사업
                  {staticSearch.orderBy === 'is_favorite' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'is_favorite', orderDir: 'DESC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'is_favorite' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'is_favorite', orderDir: 'ASC' })}
                    >
                      <ArrowDownwardIcon></ArrowDownwardIcon>
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'is_favorite', orderDir: 'ASC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell scope="row" align="center">
                  사업명
                  {staticSearch.orderBy === 'project_name' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_name', orderDir: 'DESC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'project_name' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_name', orderDir: 'ASC' })}
                    >
                      <ArrowDownwardIcon></ArrowDownwardIcon>
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_name', orderDir: 'ASC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업시작일
                  {staticSearch.orderBy === 'start_date' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'start_date', orderDir: 'DESC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'start_date' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'start_date', orderDir: 'ASC' })}
                    >
                      <ArrowDownwardIcon></ArrowDownwardIcon>
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'start_date', orderDir: 'ASC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업종료일
                  {staticSearch.orderBy === 'end_date' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'end_date', orderDir: 'DESC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'end_date' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'end_date', orderDir: 'ASC' })}
                    >
                      <ArrowDownwardIcon></ArrowDownwardIcon>
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'end_date', orderDir: 'ASC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업금액
                  {staticSearch.orderBy === 'project_amount' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_amount', orderDir: 'DESC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'project_amount' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_amount', orderDir: 'ASC' })}
                    >
                      <ArrowDownwardIcon></ArrowDownwardIcon>
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_amount', orderDir: 'ASC' })}
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  발주사
                  {staticSearch.orderBy === 'ordering_company_name' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'ordering_company_name', orderDir: 'DESC' })
                      }
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'ordering_company_name' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'ordering_company_name', orderDir: 'ASC' })
                      }
                    >
                      <ArrowDownwardIcon></ArrowDownwardIcon>
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'ordering_company_name', orderDir: 'ASC' })
                      }
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  거래처
                  {staticSearch.orderBy === 'account_company_name' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'account_company_name', orderDir: 'DESC' })
                      }
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'account_company_name' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'account_company_name', orderDir: 'ASC' })
                      }
                    >
                      <ArrowDownwardIcon></ArrowDownwardIcon>
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'account_company_name', orderDir: 'ASC' })
                      }
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업담당자
                  {staticSearch.orderBy === 'project_manager_name' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'project_manager_name', orderDir: 'DESC' })
                      }
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'project_manager_name' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'project_manager_name', orderDir: 'ASC' })
                      }
                    >
                      <ArrowDownwardIcon></ArrowDownwardIcon>
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'project_manager_name', orderDir: 'ASC' })
                      }
                    >
                      <ArrowUpwardIcon></ArrowUpwardIcon>
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {projectList.length > 0 ? (
                projectList.map((project, index) => {
                  return (
                    <CustomTableRow key={project.id}>
                      <CustomBodyCell align="center">
                        <Checkbox
                          checked={checkedProjectList.includes(project.id)}
                          onChange={(e) => handleCheckboxChange(e, project.id)}
                        />
                      </CustomBodyCell>
                      <CustomBodyCell align="center">{projectListTotal - ((page - 1) * limit + index)}</CustomBodyCell>
                      <CustomBodyCell align="center">
                        <CustomIconButton
                          iconColor={project.is_favorite === 1 ? '#FFD600' : undefined}
                          iconSize={24}
                          onClick={() => handleFavoriteToggle(project.id, project.is_favorite)}
                        >
                          {project.is_favorite === 1 ? <StarRoundedIcon /> : <StarBorderRoundedIcon />}
                        </CustomIconButton>
                      </CustomBodyCell>
                      <CustomBodyCell>
                        <span
                          onClick={() => {
                            // 확정 사업 경우
                            if (project.is_project_confirm === 1) {
                              navigate(`/project/projectCreate?id=${project.id}`);
                            }
                            // 예정 사업 경우
                            else {
                              navigate(`/project/plannedProjectCreate?id=${project.id}`);
                            }
                          }}
                          style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                          }}
                        >
                          {project.project_name}
                        </span>
                        <span
                          onClick={() => {
                            // 확정 사업 경우
                            if (project.is_project_confirm === 1) {
                              navigate(`/project/projectCreate?id=${project.id}&tab=comment`);
                            }
                            // 예정 사업 경우
                            else {
                              navigate(`/project/plannedProjectCreate?id=${project.id}&tab=comment`);
                            }
                          }}
                          style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                            color: 'red',
                            marginLeft: '4px',
                          }}
                        >
                          ({project.comment_count})
                        </span>
                        <NewCommentBadge isNewComment={project.is_read === 0} />
                      </CustomBodyCell>
                      <CustomBodyCell align="center">{project.start_date}</CustomBodyCell>
                      <CustomBodyCell align="center">{project.end_date}</CustomBodyCell>
                      <CustomBodyCell align="right">{formatAmount(project.project_amount)}원</CustomBodyCell>
                      <CustomBodyCell align="center">{project.ordering_company_name}</CustomBodyCell>
                      <CustomBodyCell align="center">{project.account_company_name}</CustomBodyCell>
                      <CustomBodyCell align="center">{project.project_manager_name}</CustomBodyCell>
                    </CustomTableRow>
                  );
                })
              ) : (
                <CustomTableRow>
                  <CustomBodyCell colSpan={9} align="center">
                    등록된 사업이 없습니다.
                  </CustomBodyCell>
                </CustomTableRow>
              )}
            </TableBody>
          </CustomTable>

          <Select
            sx={{ mt: 2, width: '100px', height: '40px' }}
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
          >
            {/* 테스트용 <MenuItem value={1}>1</MenuItem> */}
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={30}>30</MenuItem>
          </Select>

          <Pagination
            count={Math.ceil(projectListTotal / limit) || 1}
            page={page}
            onChange={onSearch}
            onProjectSearchFlag={true}
          />
        </CustomTableContainer>
      </SectionWrapper>
    </React.Fragment>
  );
};

export default ProjectListTableRowV2;
